import { MessageSquare } from "lucide-react";
import WhatsAppIcon from "@/components/WhatsAppIcon";
import { COMPANY } from "@/lib/site";

export default function FloatingTextButton() {
  return (
    <div className="fixed bottom-6 right-6 z-40 flex flex-col gap-3 items-end">
      <a
        href={COMPANY.whatsappHref}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp-btn"
        aria-label="Chat on WhatsApp"
        title="Chat on WhatsApp"
        className="group bg-[#25D366] hover:bg-[#1ebe5d] text-zinc-950 px-5 py-4 shadow-[0_20px_40px_-10px_rgba(37,211,102,0.55)] transition-colors flex items-center gap-3"
      >
        <WhatsAppIcon className="w-5 h-5" />
        <span className="font-heading text-xs tracking-[0.25em] uppercase font-semibold">
          WhatsApp
        </span>
      </a>
      <a
        href={COMPANY.smsHref}
        data-testid="floating-text-btn"
        aria-label="Text us for a quote"
        title="Text us for a quote"
        className="group bg-[#FF5A00] hover:bg-[#E04D00] text-zinc-950 px-5 py-4 shadow-[0_20px_40px_-10px_rgba(255,90,0,0.55)] transition-colors flex items-center gap-3"
      >
        <MessageSquare className="w-5 h-5" strokeWidth={2.4} />
        <span className="font-heading text-xs tracking-[0.25em] uppercase font-semibold">
          Text Us
        </span>
      </a>
    </div>
  );
}
